'use client'
import { supabase } from '@/integrations/supabase/client'

export type RpcArgs = Record<string, unknown> | undefined
export type RpcResult<T> = { data: T | null; error: Error | null }

function normalizeArgs(args?: RpcArgs): RpcArgs {
  if (!args) return args
  const a: Record<string, unknown> = { ...args }

  // map aliases → canonical and remove duplicates
  if ('limit' in a && !('_limit' in a)) { a['_limit'] = a['limit']; delete a['limit']; }
  if ('since' in a && !('p_since' in a)) { a['p_since'] = a['since']; delete a['since']; }
  if ('emailId' in a && !('email_id' in a)) { a['email_id'] = a['emailId']; delete a['emailId']; }
  if ('customerId' in a && !('customer_id' in a)) { a['customer_id'] = a['customerId']; delete a['customerId']; }
  if ('userId' in a && !('user_id' in a)) { a['user_id'] = a['userId']; delete a['userId']; }
  if ('search' in a && !('_search' in a)) { a['_search'] = a['search']; delete a['search']; }

  return a
}

export async function rpc<T = unknown>(fn: string, args?: RpcArgs): Promise<RpcResult<T>> {
  const { data, error } = await supabase.rpc(fn as any, normalizeArgs(args))
  return { data: (data as T) ?? null, error: error as any ?? null }
}

export async function rpcWithIdempotency<T = unknown>(
  fn: string, 
  args?: RpcArgs, 
  idempotencyKey?: string
): Promise<RpcResult<T>> {
  const normalizedArgs = normalizeArgs(args) ?? {}
  if (idempotencyKey) {
    normalizedArgs.idempotency_key = idempotencyKey
  }
  return rpc<T>(fn, normalizedArgs)
}